/** @jsxImportSource @emotion/react */
import React from 'react'
import Grid from '@mui/material/Grid'
import {PageContainer} from 'components'
import { StylesObject } from "types"
import { Widget } from '../../widgets'


const Reports = () => {

  return (
    <PageContainer>
      <Grid container spacing={2}>

        <Widget id="report"/>

      </Grid>
    </PageContainer>
  )
}

const styles = {

} as StylesObject

export default Reports